module.exports = __webpack_public_path__ + "static/media/yellow_light.0efd62a1.png";